"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadArbitrumCrossChainContracts = void 0;
const ethereum_1 = require("../ethereum");
const l2_bitcoin_depositor_1 = require("./l2-bitcoin-depositor");
const l2_tbtc_token_1 = require("./l2-tbtc-token");
__exportStar(require("./l2-bitcoin-depositor"), exports);
__exportStar(require("./l2-tbtc-token"), exports);
/**
 * Loads Arbitrum implementation of tBTC cross-chain contracts for the given Arbitrum
 * chain ID and attaches the given signer there.
 * @param signer Signer that should be attached to the contracts.
 * @param chainId Arbitrum chain ID.
 * @returns Handle to the contracts.
 * @throws Throws an error if the signer's Arbitrum chain ID is other than
 *         the one used to load contracts.
 */
async function loadArbitrumCrossChainContracts(signer, chainId) {
    const signerChainId = await (0, ethereum_1.chainIdFromSigner)(signer);
    if (signerChainId !== chainId) {
        throw new Error("Signer uses different chain than Arbitrum cross-chain contracts");
    }
    const l2BitcoinDepositor = new l2_bitcoin_depositor_1.ArbitrumL2BitcoinDepositor({ signerOrProvider: signer }, chainId);
    l2BitcoinDepositor.setDepositOwner(await (0, ethereum_1.ethereumAddressFromSigner)(signer));
    const l2TbtcToken = new l2_tbtc_token_1.ArbitrumL2TBTCToken({ signerOrProvider: signer }, chainId);
    return {
        l2BitcoinDepositor,
        l2TbtcToken,
    };
}
exports.loadArbitrumCrossChainContracts = loadArbitrumCrossChainContracts;
//# sourceMappingURL=index.js.map